"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/KMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_125)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_125`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 0H35.64V24H-0.359985V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 0H35.64V6H-0.359985V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 6H35.64V12H-0.359985V6Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 12H35.64V18H-0.359985V12Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.64 12L-0.359985 24V0L17.64 12Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.45404 11.979C4.45404 10.2316 5.68211 8.77896 7.3172 8.42106C7.06457 8.36492 6.80492 8.33685 6.53825 8.33685C4.52422 8.33685 2.89615 9.97194 2.89615 11.979C2.89615 13.986 4.53124 15.6211 6.53825 15.6211C6.80492 15.6211 7.06457 15.593 7.3172 15.5369C5.68211 15.179 4.45404 13.7193 4.45404 11.979Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.28211 8.84912L7.47159 9.44561H8.10316L7.59088 9.81754L7.78738 10.414L7.28211 10.0491L6.76983 10.414L6.96632 9.81754L6.46106 9.44561H7.08562L7.28211 8.84912ZM7.28211 10.414L7.47159 11.0105H8.10316L7.59088 11.3825L7.78738 11.9789L7.28211 11.607L6.76983 11.9789L6.96632 11.3825L6.46106 11.0105H7.08562L7.28211 10.414Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.28211 11.9789L7.47159 12.5754H8.10316L7.59088 12.9403L7.78738 13.5368L7.28211 13.1719L6.76983 13.5368L6.96632 12.9403L6.46106 12.5754H7.08562L7.28211 11.9789ZM7.28211 13.5368L7.47159 14.1333H8.10316L7.59088 14.5053L7.78738 15.1017L7.28211 14.7298L6.76983 15.1017L6.96632 14.5053L6.46106 14.1333H7.08562L7.28211 13.5368Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_125`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as KMFlag };
